import React, { Fragment, useState } from "react";
import Vouchers from "./vouchersWrapper/Vouchers";
import { Query } from "react-apollo";
import moment from 'moment';
import { getVouchers, getVouchersByUser } from "../../graphql/query/voucher";
import AntSpin from "../common/AntSpin";
import Exception500 from "../common/exception/500";
import FilterPeriod from "../../components/common/FilterPeriod";
import { formatDate } from "../../functions/formatDate";
import { handleInput } from "../../functions/handleInputs";

export default function VouchersWrapper({history, REMOVE_VOUCHER, user}){
    let [ periodFilter, setPeriodFilter ] = useState({
        begin: formatDate(moment().startOf('month').subtract(1, 'months').format()),
        end: formatDate(moment().endOf('month').add(1, "days").format()),
        status: "EM ANALISE"
    });
    let period = {
        begin: formatDate(moment().startOf('month').subtract(1, 'months').format()),
        end: formatDate(moment().endOf('month').add(1, "days").format()),
    };

    function getPeriod(){
        setPeriodFilter(periodFilter = {...periodFilter,
            begin: period.begin,
            end: period.end
        })
    }

    if(!user.profile_info) return <AntSpin/>
    else return(
        <Query 
            query={user.profile_info[0].label !== "User" ? getVouchers : getVouchersByUser } 
            variables={{ 
                user: localStorage.getItem('@Ossel:userid'),
                begin: periodFilter.begin,
                end: periodFilter.end 
            }}
        >
            {({ loading, error, refetch, data }) => {
                if(error){
                    return <Exception500/>
                }else{
                    switch(loading ){
                        case true:
                            return <AntSpin marginTop="10%"/> 
                        case false:
                            let props = {
                                vouchers: user.profile_info[0].label !== "User" ? data.vouchers : data.vouchersByUser,
                                history,
                                refetch,
                                REMOVE_VOUCHER,
                            };
        
                            return ( 
                                <Fragment>
                                    <FilterPeriod
                                        action={getPeriod}
                                        handleInput={handleInput}
                                        period={period}
                                    />
                                    <Vouchers props={props}/>
                                </Fragment>
                            )
                        default:
                            return null
                    }    
                }
            }}
        </Query>
    )
}


// WEBPACK FOOTER //
// ./src/components/general/VouchersWrapper.jsx